import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, FormHelperText, FormLabel, FormControl } from "@mui/material";
import { Controller } from "react-hook-form";

const CustomCheckBox = (
    {
        control,
        size = 'medium',
        name,
        label,
        labelPlacement = 'end',
        required = false,
        value = null,
        disabled = false,
        descripcion = 'Si',
        onChange = null,
        hashError = { value: false, message: '' },
        variant = "standard",
        color = "primary",
        id = null,
        preventSubmitOnEnter=true
    }
) => {
    const [checked, setChecked] = useState(value ? value.newValue : false);

    useEffect(() => {
        setChecked(value ? value.newValue : false);
    }, [value]);

    const handleOnchange = (event) => {
        setChecked(event.target.checked);
        if (onChange) {
            onChange(event.target.checked);
        }
    };

    const handleOnKeyDown = (event) => {
      if (preventSubmitOnEnter && event.keyCode === 13 ) {
          event.preventDefault()
          event.stopPropagation();
      }
  }


    return (
        <Controller
            name={name}
            id={name}
            control={control}
            rules={{ required: required }}
            render={({ field }) =>
                <FormControl
                    error={hashError.value}
                    component="fieldset"
                    variant={variant}

                >
                    <FormLabel component="legend">{label}</FormLabel>

                    <FormControlLabel
                        label={descripcion}
                        labelPlacement={labelPlacement}
                        id={id ?? name+'Id'}
                        control={
                            <Checkbox
                            onKeyDown={handleOnKeyDown}
                                {...field}
                                size={size}
                                onChange={handleOnchange}
                                checked={checked}
                                color={color}
                                disabled={disabled} />
                        }
                    />
                    <FormHelperText>{hashError.message}</FormHelperText>
                </FormControl>
            }
        />
    );
}

export default CustomCheckBox;
